import { useFormatter } from '@api/useFormatter'
import { addCommasToNumber, Texto, MomentDatePicker, Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Col, Form, Row } from 'antd'
import { NotePopover } from '../NotePopover'
import { PeriodDetailsEditButtons } from '../PeriodDetailsEditButtons'
import { FormInstance } from 'antd/lib'
import { PayPeriodShiftPay } from '../types'

const { RangePicker } = MomentDatePicker

type ShiftHeaderColumnProps = {
  shiftPay: PayPeriodShiftPay
  editing: boolean
  setEditing: (editing: boolean) => void
  form: FormInstance
}

export function ShiftHeaderColumn({ shiftPay, editing, setEditing, form }: ShiftHeaderColumnProps) {
  const formatShiftTime = (start: string, end: string) => {
    const formattedStart = start ? formatters.TIME(start) : 'Not Started'
    const formattedEnd = end ? formatters.TIME(end) : 'Not Finished'
    return `${formattedStart} — ${formattedEnd}`
  }
  const shiftIsOverwritten = !!shiftPay.override_username

  const { formatCurrency } = useFormatter()
  const formattedCurrency = formatCurrency(null, true)
  return (
    <div className='vertical-flex-center'>
      <Row className='label'>
        <Col className='pay-period-group-border vertical-flex-center px-4' span={11}>
          <Vertical alignItems='flex-end'>
            <Texto category='label' appearance='medium'>
              SHIFT START/END
            </Texto>
            {editing ? (
              <Form.Item name='shiftTimes'>
                <RangePicker allowClear showTime={{ format: 'HH:mm a' }} minuteStep={15} format='YYYY-MM-DD HH:mm' />
              </Form.Item>
            ) : (
              <>
                {shiftIsOverwritten ? (
                  <Vertical justifyContent='flex-end' alignItems='flex-end'>
                    <Texto category='label' appearance='light' style={{ textDecoration: 'line-through' }}>
                      {formatShiftTime(shiftPay.start, shiftPay.end)}
                    </Texto>
                    <Texto align='right' weight={'bold'} category='p2'>
                      {formatShiftTime(shiftPay.override_start, shiftPay.override_end)}
                    </Texto>
                  </Vertical>
                ) : (
                  <Texto align='right' weight={'bold'} category='p2'>
                    {formatShiftTime(shiftPay.start, shiftPay.end)}
                  </Texto>
                )}
              </>
            )}
          </Vertical>
        </Col>

        <Col className='pay-period-group-border vertical-flex-center pr-4' span={10}>
          <Horizontal verticalCenter gap={12}>
            <Vertical>
              <Texto align='right' category='label' appearance='medium'>
                SHIFT PAY
              </Texto>
              {shiftPay.override_shift_total ? (
                <Vertical justifyContent='flex-end' alignItems='flex-end'>
                  <Texto category='label' appearance='light' style={{ textDecoration: 'line-through' }}>
                    {formattedCurrency}
                    {addCommasToNumber(shiftPay.shift_total, 2)}
                  </Texto>
                  <Texto align='right' weight={'bold'} category='p2'>
                    {formattedCurrency}
                    {addCommasToNumber(shiftPay.override_shift_total, 2)}
                  </Texto>
                </Vertical>
              ) : (
                <Texto align='right' weight={'bold'} category='p2'>
                  {formattedCurrency}
                  {addCommasToNumber(shiftPay.shift_total, 2)}
                </Texto>
              )}
            </Vertical>
            {shiftPay.override_reason && <NotePopover order={shiftPay} />}
          </Horizontal>
        </Col>

        <Col span={3} className='vertical-flex-center items-center'>
          <PeriodDetailsEditButtons
            editing={editing}
            setEditing={setEditing}
            overrideReason={shiftPay.override_reason}
            form={form}
            payrollType='shift'
          />
        </Col>
      </Row>
    </div>
  )
}
